import React, { useEffect, useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Input, Select } from "antd";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
const CreateProjects = ({ onOpen, onClose }) => {
  const [projectType, setProjectType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    projectType: "",
  });
  const _user = useSelector((state) => state.auth.user);
  const clientId = _user?.client_id?._id || _user?._id;

  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  const fetchProjectTypes = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_PROJECT_TYPES(50),
      });
      if (response.success) {
        const types = response.data.data
          .filter((item) => item.status !== "Inactive")
          .map((item) => ({
            label: item.project_type,
            value: item._id,
          }));
        setProjectTypeOptions(types);
      }
    } catch (error) {
      console.error("Error fetching project types:", error);
    } finally {
    }
  };

  const createProject = async (data) => {
    try {
      const response = await postApi({ apiUrl: API_URLS.CREATE_PROJECT, data });
      if (response?.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } }, // 👈 Hide OK button
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         {" "}
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <h2 className="text-2xl font-semibold text-[#000000] mb-2">
        //         Project Created successfully
        //       </h2>
        //     </div>
        //   ),
        // });

        // Auto close the modal after 2s and trigger onClose

        triggerPopup("success", "Success", "Project Created successfully");

        setTimeout(() => {
          Modal.destroyAll();
          onClose();
        }, 2000);
      }
    } catch (error) {
      Modal.error({
        title: "Error",
        content: `Project not created: ${error.message}`,
      });
    } finally {
      // onClose();  // 👉 already handled inside setTimeout
    }
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = { projectType: "" };

    // Validate project type
    if (!projectType) {
      errors.projectType = "Project Services is required";
      isValid = false;
    }

    setErrorMessage(errors);

    if (isValid) {
      const data = {
        project_type: projectType,
        standard_form: [],
        custom_form: [],
      };

      await createProject(data);
    }
  };

  const handleCancel = () => {
    setProjectType("");
    setErrorMessage({ startDate: "", endDate: "", projectType: "" });
    onClose();
  };

  useEffect(() => {
    fetchProjectTypes();
  }, []);

  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className="text-[#06513D] text-xl">Create a new project</h3>
        </div>

        <div className="flex flex-col w-full mt-8">
          <Select
            showSearch
            value={projectType || null}
            onChange={setProjectType}
            placeholder="Select type of service"
            className="text-lg font-light h-14"
            allowClear
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {projectTypeOptions.map((type) => (
              <Select.Option key={type.value} value={type.label}>
                {type.label}
              </Select.Option>
            ))}
          </Select>

          {errorMessage.projectType && (
            <div className="text-red-500 text-sm">
              {errorMessage.projectType}
            </div>
          )}
        </div>
        <div className="flex justify-center gap-4 py-6">
          <CustomButton
            buttonType="#06513D"
            variant="cancel"
            buttonText="Cancel"
            className="text-sm px-6 py-2 rounded-lg"
            onClick={handleCancel}
          />
          <CustomButton
            buttonType="#06513D"
            variant="ok"
            buttonText="Save"
            className=" text-sm px-6 py-2 rounded-lg"
            onClick={handleSave}
          />
        </div>
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </DialogBox>
    </div>
  );
};

export default CreateProjects;
